import React from "react";
import { useAppSelector } from "../app/hooks";
import CreateMenu from "./menu/CreateMenu";
import AppDrawer from "../components/drawer/Drawer";
import CreateTestimonial from "./testimonial/CreateTestimonial";
import CreateSetting from "./setting/CreateSetting";
import CreateRights from "./rights/CreateRights";
import CreateFacility from "./facility/CreateFacility";
import CreateWhyChoose from "./whychoose/CreateWhyChoose";
import CreateAmenities from "./amenities/CreateAmenities";
import CreateTourType from "./tourtype/CreateTourType";
import CreateGallery from "./gallery/CreateGallery";
import CreateSignatureMoment from "./signaturemoment/CreateSignatureMoment";
import CreateExperience from "./experience/CreateExperience";
import CreatePosition from "./position/CreatePosition";
import CreateVideoGallery from "./videogallery/CreateVideoGallery";
import CreatePopup from "./popup/CreatePopup";
import CreateBlogFAQ from "./blog/CreateBlogFAQ";
import CreateCountry from "./country/CreateCountry";
import CreateState from "./state/CreateState";
import CreateCity from "./city/CreateCity";
import CreateLeadSource from "./leadsource/CreateLeadSource";
import CreateLeadStage from "./leadstage/CreateLeadStage";
import CreateLead from "./lead/CreateLead";
import CreateContact from "./contact/CreateContact";
import CreateEmailTemplate from "./emailTemplate/CreateEmailTemplate";
import CreateB2BDocument from "./b2bdocument/CreateB2BDocument";

const Drawers = () => {
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);

  //   ***********Note : Here you need to add key as a drawerName same which you passed from create Button***********

  const drawerComponents: Record<string, React.JSX.Element> = {
    menuForm: <CreateMenu />,
    testimonialForm: <CreateTestimonial />,
    settingForm: <CreateSetting />,
    rightsForm: <CreateRights />,
    facilityForm: <CreateFacility />,
    whychooseForm: <CreateWhyChoose />,
    amenitiesForm: <CreateAmenities />,
    tourtypeForm: <CreateTourType />,
    galleryForm: <CreateGallery />,
    signatureMomentForm: <CreateSignatureMoment />,
    experienceForm: <CreateExperience />,
    positionForm: <CreatePosition />,
    videoGalleryForm: <CreateVideoGallery />,
    popUpForm: <CreatePopup />,
    blogFaqForm: <CreateBlogFAQ />,
    countryForm: <CreateCountry />,
    stateForm: <CreateState />,
    cityForm: <CreateCity />,
    leadsourceForm: <CreateLeadSource />,
    leadStageForm: <CreateLeadStage />,
    leadForm: <CreateLead />,
    contactForm: <CreateContact />,
    emailTemplateForm: <CreateEmailTemplate />,
    b2bDocumentForm: <CreateB2BDocument />,
  };

  return (
    <>
      {isDrawerOpen && Object.keys(drawerComponents).includes(drawerName) && (
        <AppDrawer>{drawerComponents[drawerName]}</AppDrawer>
      )}
    </>
  );
};

export default Drawers;
